// Function to load the deck box from local storage
const getDeckBox = () => {
  const savedDecks = localStorage.getItem("scdecks");
  return savedDecks ? JSON.parse(savedDecks) : [];
};

// Function to save the deck box to local storage
const saveDeckBox = (deckBox) => {
  localStorage.setItem("scdecks", JSON.stringify(deckBox));
};

// Function to get a specific deck by its name
const getDeckByName = (deckName) => {
  const deckBox = getDeckBox();
  return deckBox.find((deck) => deck.name === deckName) || null;
};

// Create a new deck
const createDeck = (deckName) => {
  const deckBox = getDeckBox();
  if (deckBox.some((d) => d.name === deckName)) {
    throw new Error("A deck with this name already exists.");
  }
  const newDeck = {
    name: deckName,
    creationDate: new Date().toISOString(),
    cards: [] /* each: { name, hardColor, abilityGuids: [] } */,
  };
  deckBox.push(newDeck);
  saveDeckBox(deckBox);
  return newDeck;
};

// Delete a deck
const deleteDeck = (deckName) => {
  let deckBox = getDeckBox();
  deckBox = deckBox.filter((d) => d.name !== deckName);
  saveDeckBox(deckBox);
};

// Rename a deck
const renameDeck = (oldName, newName) => {
  const deckBox = getDeckBox();
  if (deckBox.some((d) => d.name === newName)) {
    throw new Error("A deck with this name already exists.");
  }
  const deck = deckBox.find((d) => d.name === oldName);
  if (!deck) throw new Error("Deck not found.");
  deck.name = newName;
  saveDeckBox(deckBox);
};

// **New**: copy an existing deck under a new name
const copyDeck = (oldName, newName) => {
  const deckBox = getDeckBox();
  if (deckBox.some((d) => d.name === newName)) {
    throw new Error("A deck with this name already exists.");
  }
  const deck = deckBox.find((d) => d.name === oldName);
  if (!deck) throw new Error("Deck not found.");
  // deep‐clone
  const clone = JSON.parse(JSON.stringify(deck));
  clone.name = newName;
  clone.creationDate = new Date().toISOString();
  deckBox.push(clone);
  saveDeckBox(deckBox);
  return clone;
};

export {
  getDeckBox,
  saveDeckBox,
  getDeckByName,
  createDeck,
  deleteDeck,
  renameDeck,
  copyDeck,
};
